import React from 'react';

import { SvgIcon } from '@mui/material';

import { IconColors } from './icon-utils';

export function ExpandedList10Icon(): JSX.Element {
  return (
    <SvgIcon style={{ height: 86, width: 62 }} viewBox="0 0 61 79">
      <g fill="none" fillRule="evenodd">
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(-1 -3)"
        >
          <tspan x="0" y="12">
            →
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(-1 -3)"
        >
          <tspan x="0" y="84">
            →
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(-1 -3)"
        >
          <tspan x="16" y="28">
            ◆
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(-1 -3)"
        >
          <tspan x="16" y="46">
            ◆
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(-1 -3)"
        >
          <tspan x="22" y="65">
            ●
          </tspan>
        </text>
        <path
          d="M16 6H62V8H16zM16 78H62V80H16zM29 23H62V25H29zM29 41H62V43H29zM33 59H62V61H33z"
          fill={IconColors.Grey}
          transform="translate(-1 -3)"
        />
      </g>
    </SvgIcon>
  );
}
